(function () {
  'use strict';

  function bind() {
    document.addEventListener('click', (event) => {
      const target = event.target.closest('[data-quick-add]');
      if (!target) return;
      event.preventDefault();
      const variantId = target.getAttribute('data-variant-id');
      if (!variantId) return;
      target.setAttribute('disabled', '');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((r) => r.json())
        .then(() => {
          document.dispatchEvent(new CustomEvent('dulceria:drawer:open'));
        })
        .finally(() => target.removeAttribute('disabled'));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
